// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {useState} from 'react';
import cn from 'classnames';
import {toolip_img_url} from '../../../../hola/pub/ui/toolip_img_url';
// @ts-ignore
import {get_json, set_json} from '/util/storage.js';
import {Lottie} from '../../../../shared/ui/lottie';

import styles from './onboarding.module.less';

/* eslint-disable */
export enum ONBOARD_EVENTS {
    welcome_visited = 'welcome_visited',
    welcome_plan = 'welcome_plan',
    configured_list = 'configured_list',
}
/* eslint-enable */

type t_side = 'top' | 'right' | 'left' | 'bottom';
type t_color = 'purple' | 'blue' | 'green' | 'brown' | 'pink';

interface i_onboarding_tooltip_props {
    side?: t_side;
    color?: t_color;
    content: JSX.Element;
}

export const Onboarding_tooltip = (props: i_onboarding_tooltip_props)=>{
    const {side = 'bottom', color = 'purple', content} = props;
    const cls = cn(styles.onboarding_tooltip, styles[color], styles[side]);
    return <div className={cls}>
      <div className={styles.pin}>
        <Lottie autoplay loop width="28" height="28"
          src={toolip_img_url('animation/onboarding_pin.json')}/>
      </div>
      <div className={styles.content}>{content}</div>
    </div>;
};

type t_onboarding_state = Record<ONBOARD_EVENTS, any>;

export const use_onboarding = ()=>{
    const [state, set_state] = useState<t_onboarding_state>(
        get_json('onboarding')||{});
    const set_onboarding = (key: ONBOARD_EVENTS, value?: any)=>{
        set_state(prev=>{
            const next = {...prev, [key]: value||Date.now()};
            set_json('onboarding', next);
            return next;
        });
    };
    return {onboarding: state, set_onboarding};
};
